import { render, staticRenderFns } from "./promotion_cost.vue?vue&type=template&id=f273927a"
import script from "./promotion_cost.vue?vue&type=script&lang=js"
export * from "./promotion_cost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports